import { defineStore } from 'pinia';
import { saveInLocalStorage, getFromLocalStorage } from '@/utils/local-storage';


const initialState = {
    myCompanies: {
        fetched: false,
        data: getFromLocalStorage('myCompanies', []),
    },

    fetched: false
}

export const useStateStore = defineStore('stateStore', {
    state: () => initialState,

    actions: {
        setMyCompanies(value, fetched = true) {
            this.myCompanies.data = value;
            this.myCompanies.fetched = fetched;
            saveInLocalStorage('myCompanies', value);
        },

        setFetched(value) {
            this.fetched = value;
        }

    }
});